import React, {FC} from 'react'
import styled from 'styled-components'
import best_date_wrapperStyles from './best_date_wrapper.styles'

const apAtomName = {ap_atom_name: 'apBestDateWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${best_date_wrapperStyles}
`

const BestDateWrapperAtom: FC = function (props) {
  return <StyledWrapper {...apAtomName} {...props} />
}

export default BestDateWrapperAtom
